<template>
    <div>
        <el-select style="width:120px;" v-model="regionValue.provinceValue" @change="getRegionList(2,regionValue.provinceValue)" :disabled="enterArea" placeholder="请选择">
            <el-option
                    v-for="item in regionData.province"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>

        <el-select style="width:120px;" v-if="regionValue.provinceValue" v-model="regionValue.cityValue" @change="getRegionList(3,regionValue.cityValue)" :disabled="enterArea" placeholder="请选择">
            <el-option
                    v-for="item in regionData.city"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>

        <el-select style="width:120px;" v-if="regionValue.cityValue" v-model="regionValue.areaValue" @change="deliverData" :disabled="enterArea" placeholder="请选择">
            <el-option
                    v-for="item in regionData.area"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>
<script>
    import {
        countryList
    }from './../../api/exam_api'
    export default{
        name:'region',
        props:['defaultData'],
        data(){
            return{
                enterArea:false,
                stintArea:false,
                stintAreaData:{},
                regionData:{
                    province:[],
                    city:[],
                    area:[]
                },
                regionValue:{
                    provinceValue:'',
                    cityValue:'',
                    areaValue:'',
                },
                regionName:{
                    provinceName:'',
                    cityName:'',
                    areaName:'',
                }
            }
        },
        methods: {
            getRegionList($type,$id,$alter){
                let data={
                    level:$type,
                    parentId:$id
                };
                countryList(data).then((res)=>{
                    if(res.code==200){
                        if(this.stintArea){
                            this.dataProcess(res.data,$type)
                        }else {
                            switch ($type) {
                                case 1:
                                    this.regionData.province=res.data;
                                    break;
                                case 2:
                                    this.regionData.city=res.data;
                                    if($alter!=-1){
                                        this.regionValue.cityValue='';
                                    }
                                    break;
                                case 3:
                                    this.regionData.area=res.data;
                                    if($alter!=-1){
                                        this.regionValue.areaValue='';
                                    }
                                    break;
                            }
                        }
                    }
                });
                this.bareData();
            },

            bareData(){
                this.$emit('getRegionData','','');
            },
            deliverData(){
                let that = this;
                this.regionData.province.forEach((index,i)=>{
                    if(index.id==that.regionValue.provinceValue){
                        that.regionName.provinceName=index.name;
                    }
                });
                this.regionData.city.forEach((index,i)=>{
                    if(index.id==that.regionValue.cityValue){
                        that.regionName.cityName=index.name;
                    }
                });
                this.regionData.area.forEach((index,i)=>{
                    if(index.id==that.regionValue.areaValue){
                        that.regionName.areaName=index.name;
                    }
                });
                this.$emit('getRegionData',this.regionValue,this.regionName);
            },

            //    编辑调用赋值方法
            putData($province,$city,$area){
                this.getRegionList(2,$province,-1);
                this.getRegionList(3,$city,-1);
                this.regionValue.provinceValue=$province;
                this.regionValue.cityValue=$city;
                this.regionValue.areaValue=$area;
            },

            //    地区限制调用方法
            stintData($data){
                this.stintAreaData=$data;
                this.stintArea=true;
                this.dataProcess(this.regionData.province,1);
            },

            //  地区数据限制处理
            dataProcess($data,$type){
                let data=[];
                if($type==1){
                    this.stintAreaData.proxyArea.forEach((index,i)=>{
                        $data.forEach((item,i)=>{
                            if(index.location_p==item.name){
                                let obj={
                                    id:item.id,
                                    name:item.name,
                                };
                                let being=false;
                                data.forEach((index,i)=>{
                                    if(obj.id==index.id){
                                        being=true;
                                    }
                                });
                                if(!being){
                                    data.push(obj);
                                }
                            }
                        });
                    });
                    this.regionData.province=data;
                }else if($type==2){
                    this.regionValue.cityValue='';
                    this.stintAreaData.proxyArea.forEach((index,i)=>{
                        $data.forEach((item,i)=>{
                            if(index.location_c==item.name){
                                let obj={
                                    id:item.id,
                                    name:item.name,
                                };
                                let being=false;
                                data.forEach((index,i)=>{
                                    if(obj.id==index.id){
                                        being=true;
                                    }
                                });
                                if(!being){
                                    data.push(obj);
                                }
                            }
                        });
                    });
                    //debugger;
                    if(data.length>0){
                        this.regionData.city=data;
                    }else{
                        this.regionData.city=$data;
                    }
                }else if($type==3){
                    this.regionValue.areaValue='';
                    this.stintAreaData.proxyArea.forEach((index,i)=>{
                        $data.forEach((item,i)=>{
                            if(index.location_a==item.name){
                                let obj={
                                    id:item.id,
                                    name:item.name,
                                };
                                let being=false;
                                data.forEach((index,i)=>{
                                    if(obj.id==index.id){
                                        being=true;
                                    }
                                });
                                if(!being){
                                    data.push(obj);
                                }
                            }
                        });
                    });
                    //debugger;
                    if(data.length>0){
                        this.regionData.area=data;
                    }else{
                        this.regionData.area=$data;
                    }
                }
            },

            //  禁用地区选择
            disabledArea(){
                this.enterArea=true;
            },
        },
        mounted(){
            this.getRegionList(1,'');
        }
    }
</script>



// WEBPACK FOOTER //
// src/assets/js/pages/common/region.vue